<script>
	import { writable } from "svelte/store";

	// wow!
	const cutoffTime = Date.parse("21 Apr 2024 21:00:00 GMT");
	const startTime = Date.parse("18 Apr 2024 09:00:00 GMT");
	const maxTime = (cutoffTime - startTime) / (1000 * 60 * 60);

	let curElapsed = (new Date() - startTime) / (1000 * 60 * 60);
	if (curElapsed < 0) curElapsed = 0;

	let distance = writable(+localStorage.distance || 1000);
	let pauseTime = writable(+localStorage.pauseTime || 24);
	let curDist = writable(+localStorage.curDist || 0);

	$: minPace = $distance / (maxTime - $pauseTime);
	$: curPace = curElapsed === 0 ? 0 : $distance / curElapsed;
	$: curMinPace = ($distance - $curDist) / curRemainingTime;
	$: curRemainingTime = (cutoffTime - new Date()) / (1000 * 60 * 60);

	distance.subscribe((val) => (localStorage.distance = val));
	pauseTime.subscribe((val) => (localStorage.pauseTime = val));
	curDist.subscribe((val) => (localStorage.curDist = val));

	$: if ($curDist === $distance) {
		const defaults = {
			spread: 360,
			ticks: 100,
			gravity: 0,
			decay: 0.94,
			startVelocity: 30,
		};

		confetti({ ...defaults, particleCount: 500 });
	}

	function incrPaused() {
		$pauseTime += 1;
	}
	function decrPaused() {
		$pauseTime -= 1;
	}

	function incrDist() {
		$distance += 50;
	}
	function decrDist() {
		$distance -= 50;
	}
</script>

<main>
	<h1>Unknown Race Calc</h1>

	<h2>In theory...</h2>

	<p>
		Total Duration: <code>{maxTime.toFixed(1)}</code> hours
	</p>

	<p>
		Total Distance: <code>{$distance}</code> km
		<button on:click={incrDist}>+</button>
		<button on:click={decrDist}>-</button>
	</p>

	<p>
		Pause: <code>{$pauseTime}</code> hours
		<button on:click={incrPaused}>+</button>
		<button on:click={decrPaused}>-</button>
	</p>

	<p>
		Min Pace: <code>{minPace.toFixed(1)}</code> km/h
	</p>

	<h2>In practice...</h2>

	<p>
		Elapsed Time: <code>{curElapsed.toFixed(1)}</code> hours
	</p>

	<p>
		Remaining Time: <code>{curRemainingTime.toFixed(1)}</code> hours
	</p>

	<p>
		Current Distance: <code>{$curDist}</code> km
	</p>

	<p>
		<input type="range" bind:value={$curDist} min="0" max={$distance} />
	</p>

	<p>
		Current pace: <code>{curPace.toFixed(1)}</code> km/h
	</p>

	<p>
		Required pace: <code>{curMinPace.toFixed(1)}</code> km/h
	</p>
</main>

<style>
	button {
		min-width: 3em;
	}
</style>
